module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "statusList"
  }, [_c('v-content', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.isDepartments == true) ? _c('div', {
    staticClass: "selectDept"
  }, [_c('v-flex', [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Select Department:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.departmentListNew,
      "item-value": "id",
      "item-text": "name",
      "label": "Select Department",
      "autocomplete": "",
      "solo": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncFilterStatuses(true)
      }
    },
    model: {
      value: (_vm.department),
      callback: function($$v) {
        _vm.department = $$v
      },
      expression: "department"
    }
  })], 1), _vm._v(" "), _c('br')], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('v-data-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fncShowStatusList()),
      expression: "fncShowStatusList()"
    }],
    ref: "sortableTable",
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "search": _vm.search,
      "items": _vm.statusList,
      "hide-actions": "",
      "disable-initial-sort": "",
      "rows-per-page-items": [20, 40, 60, 80, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [(props.item.show == true) ? _c('tr', {
          staticClass: "sortableRow",
          attrs: {
            "id": "rows"
          }
        }, [_c('td', {
          staticClass: "px-1",
          attrs: {
            "width": "5%"
          }
        }, [_c('v-btn', {
          staticClass: "sortHandle",
          staticStyle: {
            "cursor": "move"
          },
          attrs: {
            "icon": ""
          }
        }, [_c('v-icon', [_vm._v("drag_handle")])], 1)], 1), _vm._v(" "), (_vm.departmentList.length == 0 || _vm.objAuthorize.department_active == false || _vm.objAuthorize.department_active == 0) ? _c('td', {
          attrs: {
            "width": "30%"
          }
        }, [_vm._v(_vm._s(props.item.description))]) : _c('td', {
          attrs: {
            "width": "30%"
          }
        }, [_vm._v(_vm._s(props.item.description))]), _vm._v(" "), (_vm.fncGetPipelineGrouping(props.item)) ? _c('td', {
          attrs: {
            "width": "20%"
          }
        }, [_vm._v(_vm._s(_vm.fncGetPipelineGrouping(props.item)))]) : _c('td', {
          attrs: {
            "width": "20%"
          }
        }, [_c('span', {
          staticStyle: {
            "color": "red",
            "font-weight": "550"
          }
        }, [_vm._v("Not Configured")])]), _vm._v(" "), (_vm.departmentList.length != 0 && (_vm.objAuthorize.department_active == true || _vm.objAuthorize.department_active == 1) && props.item.department == null) ? _c('td', {
          attrs: {
            "width": "15%"
          }
        }, [_vm._v("N/A")]) : _vm._e(), _vm._v(" "), (_vm.departmentList.length != 0 && (_vm.objAuthorize.department_active == true || _vm.objAuthorize.department_active == 1) && props.item.department != null) ? _c('td', {
          attrs: {
            "width": "15%"
          }
        }, [_c('v-tooltip', {
          staticStyle: {
            "top": "0px !important"
          },
          attrs: {
            "bottom": ""
          }
        }, [_c('p', {
          staticStyle: {
            "cursor": "pointer",
            "padding-top": "14px",
            "float": "left",
            "display": "block"
          },
          attrs: {
            "slot": "activator"
          },
          slot: "activator"
        }, [_vm._v("View Departments")]), _vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.fncGetDepartment(props.item.department))
          }
        })])], 1) : _vm._e(), _vm._v(" "), _c('td', {
          style: ({
            background: props.item.style_colour
          }),
          attrs: {
            "width": "10%"
          }
        }), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_QUOTE_STATUSES') !== -1) ? _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncEditStatus(props.item.id, props.item.description)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("edit")])])]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_QUOTE_STATUSES') !== -1) ? _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncDeleteStatus(props.item.id, props.item.description, props.item.hasStatus)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("delete_forever")])])]) : _vm._e()]) : _c('tr', {
          staticClass: "sortableRow",
          staticStyle: {
            "display": "none !important"
          },
          attrs: {
            "id": "rows"
          }
        }, [_c('td', {
          staticClass: "px-1",
          attrs: {
            "width": "5%"
          }
        }, [_c('v-btn', {
          staticClass: "sortHandle",
          staticStyle: {
            "cursor": "move"
          },
          attrs: {
            "icon": ""
          }
        }, [_c('v-icon', [_vm._v("drag_handle")])], 1)], 1), _vm._v(" "), (_vm.departmentList.length == 0) ? _c('td', {
          attrs: {
            "width": "30%"
          }
        }, [_vm._v(_vm._s(props.item.description))]) : _c('td', {
          attrs: {
            "width": "30%"
          }
        }, [_vm._v(_vm._s(props.item.description) + " - " + _vm._s(props.item.show))]), _vm._v(" "), (_vm.fncGetPipelineGrouping(props.item)) ? _c('td', {
          attrs: {
            "width": "20%"
          }
        }, [_vm._v(_vm._s(_vm.fncGetPipelineGrouping(props.item)))]) : _c('td', {
          attrs: {
            "width": "20%"
          }
        }, [_c('span', {
          staticStyle: {
            "color": "red",
            "font-weight": "600"
          }
        }, [_vm._v("Not Configured")])]), _vm._v(" "), (_vm.departmentList.length != 0) ? _c('td', {
          attrs: {
            "width": "15%"
          }
        }, [_vm._v(_vm._s(_vm.fncGetDepartment(props.item.department)))]) : _vm._e(), _vm._v(" "), _c('td', {
          style: ({
            background: props.item.style_colour
          }),
          attrs: {
            "width": "10%"
          }
        }, [_vm._v(" ")]), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_QUOTE_STATUSES') !== -1) ? _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncEditStatus(props.item.id, props.item.description)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("edit")])])]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_QUOTE_STATUSES') !== -1) ? _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncDeleteStatus(props.item.id, props.item.description, props.item.hasStatus)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("delete_forever")])])]) : _vm._e()])]
      }
    }])
  })], 1)])], 1)], 1)
},staticRenderFns: []}